'use strict'

module.exports = heading

var all = require('../all')

function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node))
}
